import { render } from "./DDNSSetting.vue?vue&type=template&id=4ea8ca16&scoped=true"
import script from "./DDNSSetting.vue?vue&type=script&lang=js"
export * from "./DDNSSetting.vue?vue&type=script&lang=js"

import "./DDNSSetting.vue?vue&type=style&index=0&id=4ea8ca16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea8ca16"]])

export default __exports__